import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Input, Button, Table, Popconfirm, message } from 'antd';
import { DeleteOutlined, EditOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';
import TextFilter from '../components/TextFilter';

function MainSlider() {
	const [gridLoading, setGridLoading] = useState(true);
	const [gridData, setGridData] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [gridHeight, setGridHeight] = useState(window.innerWidth - 182);

	const get = (options = {}) => {
		if (!options.pagination) {
			options.pagination = { start: 0, limit: 20 };
		} else {
			options.pagination = {
				start: (options.pagination.current - 1) * options.pagination.pageSize,
				limit: options.pagination.pageSize,
			};
		}

		if (options.sorter && options.sorter.order) {
			options.sorter = {
				field: options.sorter.field,
				order: options.sorter.order,
			};
		} else {
			options.sorter = { field: '_id', order: 'desc' };
		}

		if (options.filters) {
			// options.filters = _.omitBy(options.filters, _.isNil);
		}

		axios
			.get(`/main-slider`, { params: options })
			.then((result) => {
				// console.log(result);
				setGridData(result.data.data);
				setTotalRecords(result.data.data.length);
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const deleteRecord = (record) => {
		setGridLoading(true);
		axios
			.delete(`/main-slider`, { data: { _id: record._id } })
			.then((result) => {
				message.success(result.data.message);
				get();
			})
			.catch(() => {
				message.error('Oops! Something went wrong!');
			})
			.finally(() => {
				setGridLoading(false);
			});
	};

	const onTableChange = (pagination, filters, sorter) => {
		get({ pagination, filters, sorter });
	};

	useEffect(() => {
		get();
		window.onresize = () => {
			setGridHeight(window.innerWidth - 182);
		};
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						label: 'Main Slider',
					},
				]}
			/>
			<div className='main-content'>
				<div className='page-header'>
					<div className='page-title'>Main Slider</div>
					<div className='page-title-more'>
						<Input.Search placeholder='Search' style={{ width: '140px' }} />
						<Link to='/main-slider/add'>
							<Button icon={<PlusCircleOutlined />} type='primary'>
								Add
							</Button>
						</Link>
					</div>
				</div>
				<div className='grid-content'>
					<Table
						tableLayout='fixed'
						bordered
						size='small'
						rowKey='_id'
						showSorterTooltip={false}
						// loading={gridLoading}
						dataSource={gridData}
						scroll={{ x: 850, y: gridHeight }}
						pagination={{
							defaultPageSize: 20,
							showLessItems: true,
							showQuickJumper: true,
							showSizeChanger: true,
							pageSizeOptions: [20, 50, 100, 200],
							size: 'small',
							responsive: true,
							total: totalRecords,
							showTotal: (total) => `Total ${total} items`,
						}}
						columns={[
							{
								title: 'Action',
								key: 'action',
								align: 'center',
								fixed: 'left',
								width: 80,
								render: (text, record, index) => (
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-around',
											alignItems: 'center',
										}}
									>
										<Link to={`/main-slider/edit/${record._id}`}>
											<EditOutlined className='grid-edit-icon' />
										</Link>
										<Popconfirm
											title='Are you sure you want to delete this record?'
											okText='Yes'
											cancelText='No'
											size='small'
											placement='bottomLeft'
											onConfirm={() => {
												deleteRecord(record);
											}}
										>
											<DeleteOutlined style={{ fontSize: 14 }} />
										</Popconfirm>
									</div>
								),
							},
							{
								title: 'Slider Heading',
								dataIndex: 'sliderHeading',
								sorter: true,
								ellipsis: true,
								width: 200,
								filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => <TextFilter />,
								filterIcon: <SearchOutlined />,
							},
							{
								title: 'Slider Description',
								dataIndex: 'sliderDescription',
								ellipsis: true,
							},
						]}
					/>
				</div>
			</div>
		</>
	);
}
export default MainSlider;
